import { ReactNode } from 'react';
import styles from './Footer.module.scss';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

const FooterTile = ({
    id,
    title,
    children,
    isMobile,
}: {
    id: string;
    title: string;
    children: ReactNode;
    isMobile?: boolean;
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    if (isMobile) {
        return (
            <div className="flex flex-col gap-6">
                <p
                    role="heading"
                    className="text-sm font-medium text-colourContainerTertiary"
                    {...inspectorProps({ fieldId: 'title' })}
                >
                    {title}
                </p>
                {children}
            </div>
        );
    }

    return (
        <div className={`hidden md:block ${styles.footerTile}`}>
            <p
                role="heading"
                className="text-sm font-medium text-colourContainerTertiary"
                {...inspectorProps({ fieldId: 'title' })}
            >
                {title}
            </p>
            {children}
        </div>
    );
};

export default FooterTile;
